import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({
    isLoggedIn: null,
    token: "",
    email: "",
    company: "",
    company_address: "",
    cust_id: "",
    cust_num: null,
    cust_name: "",
    cell_phone: "",
    phone: "",
    name: "",
    session: "",
    status: -1,
    uid: 0,
    hdcase: undefined,
    loginErr: 0,
    isDone: false,
    permision: {
      case: true,
      call: true,
      job: true,
      equipment: true,
      invoice: true,
      contract: true,
      order: true,
      shipment: true,
      quote: true,
      rma: true,
    },
  }),
  getters,
  mutations,
  actions,
};